// extracted by mini-css-extract-plugin
module.exports = {"root":"BooleanFormatter_root__C2OR0"};